/// <reference path="UrlTemplate.js" />
/// <reference path="ListBase.js" />
/// <reference path="SearchBox.js" />
/// <reference path="SortableBox.js" />

class PlazaList extends ListBase {
	constructor(el, options) {
		super(el, Object.assign({ pagingEffect: 'vertSlide', tags: [], searchPhrases: [] }, options));
		this.initializeSearchBox();
		this.initializeSortableBox('a');
		this.sorterControl = this.el.querySelector('.sorterBtns');
		legacyGlobal.registerTagSearchableList(this);
	}

	loadPage(page) {
		super.loadPage(page);
		var tagCloud = legacyGlobal.findTagCloud();
		if (tagCloud != undefined) {
			tagCloud.preUpdate();
		}
		this.standardJSONRequest(
			new UrlTemplate(this.options.url).r('PLH_page', page).r('PLH_Csearch', this.options.searchPhrases.join(',')).r('PLH_Ctag', this.options.tags.join(',')).r('PLH_PlazaListSorting', this.options.sortOrder).url
		);
	}

	onLoadPage(pageEl) {
		super.onLoadPage(pageEl);
		if (this.options.sorters != undefined && this.sorterControl != undefined) {
			this.sorterControl.innerHTML = this.options.sorters;
			this.initializeSortableBox('a');
		}
		if (this.options.tagCloud != undefined) {
			var tagCloud = legacyGlobal.findTagCloud();
			if (tagCloud != undefined) {
				tagCloud.innerHTML = this.options.tagCloud;
			}
		}
	}

	refresh() {
		this.loadPage(0);
		this.el.dispatchEvent(new CustomEvent('list:criteriaChanged', { detail: { options: this.options } }));
	}

	addTag(tag) {
		this.options.tags.push(tag);
		this.refresh();
	}

	removeTag(tag) {
		this.options.tags = this.options.tags.without(tag);
		this.refresh();
	}
}

Object.assign(PlazaList.prototype, SearchBox);
Object.assign(PlazaList.prototype, SortableBox);
